<template>
  <v-container>
    <v-img src="@/assets/images/login-header.svg" contain max-height="255" />
    <v-row class="text-center mt-10 justify-center">      
      <v-col xl="6" lg="6" md="10" cols="12">
        <div class="mb-5">
          <h2 class="signin-title text-center">Welcome</h2>
          <p class="signin-subtitle">Please sign into your account</p>
        </div>
        <div ref="form" class="sign-in-form">
          <v-form v-model="formValid" @submit.prevent="logMeIn" onSubmit="return false;">
            <label>Email</label>
            <v-text-field
              placeholder="username@example.com"
              v-model="email"
              :rules="[rules.required,rules.email]"
              outlined
              required
              autofocus
              class="emailText"
              @blur="email = email.toLowerCase()"
            />

            <div>
              <label>Password</label>
              <v-text-field
                v-model="password"
                :rules="[rules.required]"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                :hide-details="true"
                required
                outlined
                @click:append="showPassword = !showPassword"
              />
              <v-btn
                text
                to="/forgot-password"
                color="primary"
                x-small
                plain
              >
                Forgot password?
              </v-btn>
            </div>

            <recaptcha
              @verify="verified = true"
              @expired="verified = false"
            />

            <v-btn
              type="submit"
              :disabled="!formValid || !verified"
              class="px-10 mt-10"
              color="primary"
              x-large
            >
              Sign In
            </v-btn>
          </v-form>
        </div>
      </v-col>
      <v-col cols="12">
        <h6 class="text-center">
          Haven't created an account yet? <br />
          <v-btn
            text
            color="primary"
            x-small
            plain
            class="px-0"
            @click.prevent="$router.push({ name: 'create-user' }).catch(() => {})"
          >
            Click here
          </v-btn>
          to do it now.
        </h6>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import signInMixin from '@/mixins/signIn.mixin';
import Recaptcha from '../components/Recaptcha.vue';

export default {
  name: "SignIn",

   mixins: [signInMixin]
}
</script>

<style lang="scss">
.emailText {
  input {
    text-transform: lowercase !important;
  }
}

.sign-in-form {
  label {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 13px;
    display: block;
    text-align: left;
    opacity: .8;
  }
}
</style>
